import React from "react";
import { connect } from "react-redux";
import CustomLabel from "../../../sub/CustomLabel";
import Paginator from "../../../sub/Paginator";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../../../util/Util";
import ConfirmationModal from "../../../sub/modals/ConfirmationModal";
import CompanyListingRow from "./CompanyListingRow";
import CompanyListingUserModal from "./CompanyListingUserModal";
import CompanyAddModal from "./../CompanyAdd/CompanyAddModal";
import NotificationModal from "../../../sub/modals/NotificationModal";
import { Button, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";
import TableToolbar from "../../../sub/bootstrap/TableToolbar";
import Select from "react-select";

class CompanyListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
      urlFilter: "",
      groupFilter: null,
    };

    this.paginator = new Paginator(this);
  }

  closeModal() {
    this.setState({ modal: null });
  }

  updateChildState(data) {
    this.setState(data);
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          isOpen={true}
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openErrorModal(ModalTitle, ModalContent) {
    this.setState({
      modal: (
        <NotificationModal
          isOpen={true}
          title={ModalTitle}
          content={ModalContent}
          variant="danger"
          successCallback={() => true}
          closeModal={(e) => this.closeModal()}
        />
      ),
    });
  }

  openNotifModal(ModalTitle, ModalContent, successCallback) {
    this.setState({
      modal: (
        <NotificationModal
          isOpen={true}
          title={ModalTitle}
          content={ModalContent}
          variant="success"
          successCallback={() => true}
          closeModal={(e) => this.closeModal()}
        />
      ),
    });
  }

  openAddCompanyModal() {
    this.setState({
      modal: <CompanyAddModal close={() => this.closeModal()} />,
    });
  }

  openUsersModal(company) {
    this.setState({
      modal: (
        <CompanyListingUserModal
          company={company}
          close={() => this.closeModal()}
        />
      ),
    });
  }

  openEditModal(company) {
    this.setState({
      modal: (
        <CompanyAddModal company={company} close={() => this.closeModal()} />
      ),
    });
  }

  areResultsFiltered = () => {
    return (
      !Util.emptyString(this.state.nameFilter) ||
      !Util.emptyString(this.state.urlFilter) ||
      this.state.groupFilter
    );
  };

  resetSearchFields() {
    this.setState({
      nameFilter: "",
      urlFilter: "",
      groupFilter: null,
    });
  }

  getSelectOptions() {
    if (!this.props.groups || this.props.groups.length === 0) return;

    const options = [];
    for (const g of this.props.groups) {
      options.push({
        value: g._id,
        label: g.name,
      });
    }
    return options;
  }

  render() {
    this.paginator.init(this.props.company.length);
    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    var companiesNodes =
      this.props.company !== undefined &&
      this.props.company.length > 0 &&
      this.props.company.map((company) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            company.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (this.state.urlFilter && this.state.urlFilter !== "") {
          if (
            company.url
              .toLowerCase()
              .indexOf(this.state.urlFilter.toLowerCase()) === -1
          )
            return null;
        }

        if (this.state.groupFilter) {
          if (company.group_id !== this.state.groupFilter.value) return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <CompanyListingRow
            key={company._id}
            company={company}
            openErrorModal={(title, content) =>
              this.openErrorModal(title, content)
            }
            openNotifModal={(title, content, successCallback) =>
              this.openNotifModal(title, content, successCallback)
            }
            openConfModal={(title, content, successCallback) =>
              this.openConfModal(title, content, successCallback)
            }
            openUsersModal={(company) => this.openUsersModal(company)}
            openEditModal={(company) => this.openEditModal(company)}
          />
        );
      });

    //******** RESET BUTTON  ************/
    let resetSearchButton = () => {
      let button = (
        <button className="btn btn-outline-secondary" disabled>
          <Icon icon="filter" />
        </button>
      );

      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <div>
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Remove.Filter" />}
                </Tooltip>
              )}
              placement="bottom"
            >
              <button
                id="searchFilterBtn"
                className="btn btn-warning"
                onClick={() => this.resetSearchFields()}
              >
                <Icon icon="filter" />
              </button>
            </OverlayTrigger>
          </div>
        );
      } else {
        return button;
      }
    };

    return (
      <Container fluid>
        <TableToolbar>
          <CustomLabel
            label={this.props.intl.formatMessage({
              id: "Name",
            })}
            htmlFor="search_company"
            labelClassName="my-1 mr-2"
          />
          <input
            id="search_company"
            className="form-control mr-sm-3"
            type="search"
            onChange={(e) => {
              this.setState({ nameFilter: e.target.value });
            }}
            placeholder={this.props.intl.formatMessage({ id: "Name" })}
            disabled={disableFormInput}
            value={this.state.nameFilter}
          />

          <CustomLabel
            label={this.props.intl.formatMessage({
              id: "URL",
            })}
            htmlFor="search_company_url"
            labelClassName="my-1 mr-2"
          />
          <input
            id="search_company_url"
            className="form-control mr-sm-3"
            type="search"
            onChange={(e) => {
              this.setState({ urlFilter: e.target.value });
            }}
            placeholder={this.props.intl.formatMessage({ id: "URL" })}
            disabled={disableFormInput}
            value={this.state.urlFilter}
          />

          <CustomLabel
            label={this.props.intl.formatMessage({
              id: "Group",
            })}
            htmlFor="search_group"
            labelClassName="my-1 mr-2"
          />
          <Select
            placeholder={<FormattedMessage id="Select" />}
            options={this.getSelectOptions()}
            isClearable
            noOptionsMessage={() => <FormattedMessage id={"No.Result"} />}
            onChange={(option) => this.setState({ groupFilter: option })}
            value={this.state.groupFilter}
            id="search_group"
            className="mr-3"
          />

          {resetSearchButton()}
          <Button
            variant="info"
            className="ml-auto"
            onClick={() => this.openAddCompanyModal()}
          >
            <FormattedMessage id="Pharmacy.Add" />
          </Button>
        </TableToolbar>

        <table className="table tablee4mad">
          <thead>
            <tr>
              <th scope="col">
                <FormattedMessage id="Name" />
              </th>
              <th scope="col">
                <FormattedMessage id="URL" />
              </th>
              <th scope="col">
                <FormattedMessage id="Group" />
              </th>
              <th scope="col">
                <FormattedMessage id="Creation.Date" />
              </th>
              <th scope="col">
                <FormattedMessage id="API" />
              </th>
              <th
                scope="col"
                className="col-2 align-middle text-center tdaction"
              >
                <FormattedMessage id="Actions" />
              </th>
            </tr>
          </thead>
          <tbody>{companiesNodes}</tbody>
        </table>
        {this.paginator.render()}

        {this.state.modal}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
    groups: state.groups,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyListing));
